import React, {Component} from 'react';
import {Button, Grid} from 'material-ui';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    withMobileDialog,
} from 'material-ui/Dialog';
import {
    Field,
    reduxForm
} from 'redux-form';
import {BackDropCMS} from '../../components/backdrop/backdrop_cms';
import {InputSelectField} from '../../components/fields/field_input_select_menus';
import {MENU_TYPE_HEADER, MENU_TYPE_FOOTER} from './constants';

class MenuAddTranslationDialog extends Component {

    getSitesWithoutMenu = (menus, sites, type) => {
        let siteIds = [];

        menus.map(menu => {
            if (type === MENU_TYPE_HEADER && menu.type.id === type) {
                siteIds.push(menu.site.id);
            }
            if (type === MENU_TYPE_FOOTER && menu.type.id === type) {
                siteIds.push(menu.site.id);
            }

            return siteIds;
        });

        siteIds.map(id => {
            for (let i = 0; i < sites.length; i++) {
                if (sites[i].id === id) {
                    sites.splice(i, 1);
                }
            }

            return sites;
        });

        return sites;
    }

    render() {
        const {
            menuId,
            sites,
            menus,
            handleSubmit,
            handleClose,
            open,
            classes,
            pristine,
            submitting,
        } = this.props;

        let type;
        
        menus.map(menu => {
            if (menu.id === menuId) {
                type = menu.type.id;
            }

            return type;
        });

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                classes={{
                    paper: classes.paper,
                }}
                BackdropComponent={BackDropCMS}
            >
                <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                    <DialogTitle>{"Add Menu for site"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Select below the website for which you are adding the menu:
                        </DialogContentText>
                        <Grid item xs={12}>
                            <Field
                                id="select-site"
                                name="siteId"
                                component={InputSelectField}
                                label="Select Website"
                                options={this.getSitesWithoutMenu(menus, sites, type)}
                                fullWidth={true}
                                InputLabelProps={{
                                    required:true,
                                }}
                                className={classes.selectMenuItemAddTranslation}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsButtons}>
                        <Button onClick={handleClose} variant="raised">Cancel</Button>
                        <Button disabled={pristine || submitting} variant="raised" color="primary" type="submit">Save</Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default reduxForm({
    form: 'MenuAddTranslationDialog',
    enableReinitialize: true,
}) (withMobileDialog()(MenuAddTranslationDialog));


// WEBPACK FOOTER //
// ./src/containers/menus/MenuAddTranslationDialog.jsx